import { QueryParams } from '@yme/common/constants';
export const CMP_LINK_QUERIES = {
    filterKey: 'filter',
    discountedKey: QueryParams.DISCOUNTED_MODE,
};
